// SHARED-003: Phase coordination store (simplified — prepare snapshot only)
import { create } from 'zustand';
import type { PrepareResult } from '../types/phase-contracts';

interface PhaseState {
  currentPrepare: PrepareResult | null;
  updatePrepare: (result: PrepareResult) => void;
}

export const usePhaseStore = create<PhaseState>()((set) => ({
  currentPrepare: null,
  updatePrepare: (result) => set({ currentPrepare: result }),
}));
